import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { SITES_PROVIDER } from './sites-provider.token';

/** Redirects bare `/app` to the user's first site's overview, or to `/app/onboarding` if they have none. */
export const firstSiteRedirectGuard: CanActivateFn = () => {
  const sites = inject(SITES_PROVIDER);
  const router = inject(Router);

  const cached = sites.sites();
  if (cached.length > 0) {
    return router.createUrlTree(['/app/sites', cached[0].id, 'overview']);
  }

  return sites.loadSites().pipe(
    map((list) =>
      list.length > 0
        ? router.createUrlTree(['/app/sites', list[0].id, 'overview'])
        : router.createUrlTree(['/app/onboarding']),
    ),
    catchError(() => of(router.createUrlTree(['/app/onboarding']))),
  );
};
